import { useEffect, useState } from "react";

// @mui material components
import {
  Box,
  Button,
  Divider,
  FormControl,
  FormHelperText,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Icon,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useLocation, useNavigate } from "react-router-dom";
import SigninLayout from "../../../layout/SigninLayout";
import bgImage from "../../../assest/crmlogin.jpg";
import BASEURL from "../../Utils/Baseurl";
import request, { gql } from "graphql-request";
import MaterialBox from "../../../components/MaterialBox";
import MaterialButton from "../../../components/MaterialButton";
import MaterialInput from "../../../components/MaterialInput";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { LOGIN } from "../../../lib/graphQL/graphMutation";
import { useAuth } from "../../../context/AuthContext/AuthContextProvider";
import { useLoading } from "../../../context/LodingContext";

import NoAccessPage from "./noAccessPage";
import AuthLoader from "./authLoader";

function Signin() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setAuthenticated, setCurrentUser, authenticated, currentUser } =
    useAuth();

  //   useEffect(() => {
  //     const status = localStorage.getItem("login");
  //     setAuthenticated(status);
  //   }, [authenticated]);

  //   useEffect(() => {
  //     const user = localStorage.getItem("token");
  //     setCurrentUser(user);
  //   }, [currentUser]);

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
    animation: false
  });  

  const [signInData, setSignInData] = useState({
    email: "",
    password: null,
    emailStatus: "unchecked",
    passwordStatus: "unchecked",
  });

  const [stage] = useState("sign-in");
  // useEffect(() => {
  //   const storedToken = localStorage.getItem("token");
  //   const isLoggedIn = localStorage.getItem("login");

  //   if (storedToken && isLoggedIn) {
  //     setAuthenticated(true);
  //     setCurrentUser(JSON.parse(storedToken));
  //   } else {
  //     setAuthenticated(false);
  //     setCurrentUser(null);
  //   }
  // }, []);

  const [viewPassword, setViewPassword] = useState(false);
  const { circleLoading, setCirleLoading } = useLoading();

  useEffect(() => {
    setPageState({
      ...pageState,
      state: "default",
    });
    // window.localStorage.removeItem("CRM");
  }, []);


  useEffect(() => {
    console.log("checking");
    
    const params = new URLSearchParams(location.search);
    const email = params.get("email");
    const password = params.get("password");
    console.log("email",email);
    
    if (email && password) {
      handleDirectLogin(email, password);
    } else {
      setPageState((prev) => 
        ({ ...prev, state: "default" })
    );
    }
  }, [location.search]);


  //Function to direct loging in
  const handleDirectLogin = async (email, password) => {
    setPageState({ ...pageState, loading: true });
    setCirleLoading(true);
    try {
      console.log(email,password,"in");
      
      const response = await request(BASEURL, LOGIN, { email, password });
      if (response.tokenAuth.success) {
        setAuthenticated(true);
        const user = response.tokenAuth.user;
        localStorage.setItem("userRole", user.role);
        setCurrentUser(user);
        navigate("/dashboard");
      } else {
         setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: "You don't have access to this page",
          animation: true
        });
      }
    } 
    catch(error){
      console.error("Error on direct logging",error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: "An error occurred. Please try again.",
        animation: true
      });
    } 
    finally{
      setCirleLoading(false);
    }
  };



  const handlePasswordVisibility = () => {
    setViewPassword(!viewPassword);
  };

  /**
   * Handles the change event for form inputs.
   * @param {Object} event - The event object generated by the change event.
   * @returns {void}
   */
  const handleChange = (event) => {
    const emailRegex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,6}$/g);
    //lowercase regex expression
    const lowerCaseRegex = new RegExp("^(?=.*[a-z])");
    //uppercase regex expression
    const upperCaseRegex = new RegExp("^(?=.*[A-Z])");
    //number regex expression
    const numberRegex = new RegExp("^(?=.*[0-9])");
    //special character regex expression
    const specialCharacterRegex = new RegExp("^(?=.*[@$!%*?&])");
    //length regex expression
    const lengthRegex = new RegExp("([a-zA-Z0-9@$!%*?&]{8,})$");

    let signInState = { ...signInData };
    if (event.target.name === "email") {
      if (emailRegex.test(event.target.value) === true) {
        signInState.emailStatus = "success";
      } else {
        signInState.emailStatus = "error";
      }
      signInState[event.target.name] = event.target.value;
    } else if (event.target.name === "password") {
      if (
        lowerCaseRegex.test(event.target.value) ||
        upperCaseRegex.test(event.target.value) ||
        numberRegex.test(event.target.value) ||
        specialCharacterRegex.test(event.target.value) ||
        lengthRegex.test(event.target.value) === true
      ) {
        signInState.passwordStatus = "success";
      } else {
        signInState.passwordStatus = "error";
      }
      signInState[event.target.name] = event.target.value;
    }
    setSignInData(signInState);
  };

  const handleSignIn = async () => {
    const { email, password } = signInData;
    setPageState({ ...pageState, loading: true });
    setCirleLoading(true);
    try {
      const response = await request(BASEURL, LOGIN, { email, password });
      if (response.tokenAuth.success) {
        setAuthenticated(true);
        const user = response.tokenAuth.user;
        localStorage.setItem("userRole", user.role);
        // localStorage.setItem("login", true);
        // localStorage.setItem("token", JSON.stringify(response.tokenAuth.user));
        setCurrentUser(response.tokenAuth.user);
        setPageState({
          ...pageState,
          loading: false,
          error: false,
          message: "Successfully Logged in",
          state: "default",
        });
        navigate("/dashboard");
      } else {
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: "Please check entered details",
        });
      }
    } catch (error) {
      console.error(error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: "An error occurred. Please try again.",
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const keydownHandler = (event) => {
    if (event.key == "Enter") {
      handleSignIn();
    }
  };
  return (
    <>
    {pageState.animation ? (
      <NoAccessPage/>
      // <AuthLoader/>
      ): 
      <SigninLayout
        // title="KEELS"
        description="Enter your email and password to sign in"
        illustration={bgImage}
      >
        {pageState.error === true && (
          <Dialog maxWidth="sm" open={pageState.error} fullWidth>
            <DialogTitle>
              <Typography variant="body1">{pageState.title}</Typography>
            </DialogTitle>
            <DialogContent variant="body2">{pageState.message}</DialogContent>
            <DialogActions>
              <Button
                color="error"
                variant="text"
                onClick={() =>
                  setPageState({
                    ...pageState,
                    loading: false,
                    error: false,
                    title: "",
                    message: "",
                    state: "default",
                  })
                }
              >
                close
              </Button>
            </DialogActions>
          </Dialog>
        )}

        {pageState.state === "default" && (
          <MaterialBox component="form" role="form">
            {stage === "sign-in" && (
              <>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <MaterialInput
                      fullWidth
                      onKeyDown={keydownHandler}
                      placeholder="Email"
                      name="email"
                      variant="outlined"
                      value={signInData.email}
                      onChange={handleChange}
                      error={signInData.emailStatus === "error" ? true : false}
                      success={
                        signInData.emailStatus === "success" ? true : false
                      }
                    />
                    {signInData.emailStatus === "error" ? (
                      <FormControl error>
                        <FormHelperText>
                          Please enter valid email address
                        </FormHelperText>
                      </FormControl>
                    ) : null}
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <MaterialInput
                      fullWidth
                      onKeyDown={keydownHandler}
                      placeholder="Password"
                      name="password"
                      type={viewPassword ? "text" : "password"}
                      variant="outlined"
                      value={signInData.password}
                      onChange={handleChange}
                      error={signInData.passwordStatus === "error" ? true : false}
                      success={
                        signInData.passwordStatus === "success" ? true : false
                      }
                      icon={
                        viewPassword
                          ? {
                              direction: "right",
                              component: (
                                <Icon color="action" fontSize="small">
                                  <VisibilityIcon
                                    onClick={handlePasswordVisibility}
                                    style={{ cursor: "pointer" }}
                                  />
                                </Icon>
                              ),
                            }
                          : {
                              direction: "right",
                              component: (
                                <Icon color="action" fontSize="small">
                                  <VisibilityOffIcon
                                    onClick={handlePasswordVisibility}
                                    style={{ cursor: "pointer" }}
                                  />
                                </Icon>
                              ),
                            }
                      }
                    />
                    {signInData.passwordStatus === "error" ? (
                      <FormControl error>
                        <FormHelperText>
                          Your password must be minimum 1 characters.
                        </FormHelperText>
                      </FormControl>
                    ) : null}
                  </Grid>
                </Grid>
                <MaterialBox display="flex" justifyContent="flex-end" my={2}>
                  <MaterialButton
                    variant="text"
                    color="black"
                    onClick={() => {
                      navigate("/sign-in/forgotemail");
                    }}
                    sx={{ padding: 0 }}
                    // disabled={signInData.emailStatus === "success" ? false : true}
                  >
                    Forgot Password ?
                  </MaterialButton>
                </MaterialBox>
                <MaterialBox my={2}>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    fullWidth
                    onClick={() => {
                      handleSignIn();
                    }}
                    disabled={
                      signInData.emailStatus === "success" &&
                      signInData.passwordStatus === "success"
                        ? false
                        : true
                    }
                  >
                    Sign in
                  </MaterialButton>
                </MaterialBox>
                {/* <MaterialBox position="relative" >
                                          <Divider />
                                          <MaterialBox
                                              position="absolute"
                                              top="50%"
                                              left="50%"
                                              px={1.5}
                                              lineHeight={1}
                                              sx={{ transform: "translate(-50%, -60%)" }}
                                          >
                                              <MaterialTypography variant="button" fontWeight="medium" color="black">
                                                  or
                                              </MaterialTypography>
                                          </MaterialBox>
                                      </MaterialBox>
                                      <MaterialBox>
                                          <MaterialButton
                                              variant="contained"
                                              color="dark"
                                              size="large"
                                              fullWidth
                                              onClick={() => {
                                                  navigate('/')
                                              }}
                                          // disabled={
                                          //     phoneStatus.status === 'success' ? false : true
                                          // }
                                          // loading={loading}
                                          >
                                              sign up
                                          </MaterialButton>
                                      </MaterialBox> */}
              </>
            )}
            {stage === "forget-password" && (
              <>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <MaterialInput
                      fullWidth
                      placeholder="Email"
                      name="email"
                      variant="outlined"
                      value={signInData.email}
                      onChange={handleChange}
                      error={signInData.emailStatus === "error" ? true : false}
                      success={
                        signInData.emailStatus === "success" ? true : false
                      }
                    />
                  </Grid>
                </Grid>
                <MaterialBox my={2}>
                  <MaterialButton
                    variant="contained"
                    color="dark"
                    fullWidth
                    onClick={() => {
                      handleSignIn();
                    }}
                    disabled={
                      signInData.emailStatus === "success" &&
                      signInData.passwordStatus === "success"
                        ? false
                        : true
                    }
                  >
                    Sign in
                  </MaterialButton>
                </MaterialBox>
              </>
            )}
          </MaterialBox>
        )}
      </SigninLayout>
    }

    
    </>
  );
}

export default Signin;
